import React from 'react';
import '../../styles/PresentationHomogene.css';
import ImgGareTroo from '../../images/Gare1.jpg';
import ImgGareTroo2 from '../../images/GareRue.jpg';

const Gare = () => {
    return (
        <div className='presentation-section' lang='fr'>
            <div className='presentation-card'>
                <div className='section-header'>
                    <h1 className='section-title'>La Gare et son musée</h1>
                </div>
                
                <div className='section-content' lang='fr'>
                    <div className='section-image'>
                        <img src={ImgGareTroo} alt="Gare de Troo" />
                    </div>
                    <div className='section-text'>
                        <p className='section-description'>
                            La gare de Trôo située sur le territoire de Saint Quentin lès Trôo (commune
                            rattachée à Montoire sur le Loir) est gérée par les bénévoles de l'Amicale de la
                            Gare de Trôo qui agissent en liaison avec les bénévoles d'autres associations
                            locales (TTVL : Association Train Touristique de la Vallée de Loir, Cœur de
                            Trôo, Hist'Orius, Montoire Accordéon, ...).
                        </p>
                    </div>
                    <div className='section-image'>
                        <img src={ImgGareTroo2} alt="Vue extérieure de la Gare de Troo" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gare;